import { makeStyles } from "@material-ui/core";

export const approverNameFieldStyles = makeStyles((theme) => ({
    alertWrapper: {
        paddingBottom: theme.spacing(2)
    }
}));
